import React, { useState } from 'react'
import styled from 'styled-components'
import { Text } from 'ui'
import { CouponSlugProps } from './types'
import { BackArrowIcon, CouponIcon, LoveIcon } from './icons'
import { FlexSpaceBetween, DueDate, CouponCompanyLogoWrapper, SmallImageContainer } from './SharedStyledComponents'
import { useCountdown } from '../../../utils/countdown'
import BlurhashImage from '../../../components/BlurhashImage'
import isMobile from 'utils/isMobile'
import { LoveIconContainer } from './CouponCard'




const ShareSpaceBetween = styled(FlexSpaceBetween)`
@media (max-width: 1081px) {
  padding-bottom: 16px;
}
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 20px;
  padding: 40px;
  background: white;
  border-radius: 16px;
  margin: 20px;
  min-height: 600px;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  background: white;
  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 1081px) {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    padding: 0;
    padding-bottom: 100px;
    margin: 0;
    gap: 0;
    z-index: 9999;
    background: #F6F6F6;
  }
`

const SlugContainer = styled.div`
display: flex;
width: 1384px;
height: 601px;
gap: 24px;
flex-shrink: 0;
background: white;
@media (max-width: 1081px) {
  flex-direction: column;
  width: 100%;
  height: auto;
  gap: 0;
  background: #F6F6F6;
}
`

const BackButton = styled.div`
display: flex;
width: 40px;
height: 90px;
justify-content: center;
align-items: center;
gap: 10px;
border-left: 1px solid var(--Neutral-Borders-Minimal, #E7E7E7);
cursor: pointer;

@media (max-width: 1081px) {
  width: 32px;
  height: 60px;
  border-left: 1px solid rgba(255, 255, 255, 0.3);
}
`

const DetailsContainer = styled.div`
display: flex;
width: 459px;
flex-direction: column;
align-items: center;
gap: 16px;
flex-shrink: 0;

@media (max-width: 1081px) {
  width: 100%;
  order: 2;
  gap: 16px;
  padding: 16px;
}
`

const BackButtonWithCouponNameContainer = styled.div`
display: flex;
width: 459px;
align-items: center;
gap: 16px;
flex-shrink: 0;
border-radius: 12px;
background: var(--Benefits-Surface-Main, #16AA40);
padding: 16px;

@media (max-width: 1081px) {
  width: 100%;
  border-radius: 0;
  padding: 20px 16px;
  gap: 12px;
}
`

const CouponNameContainer = styled.div`
display: flex;
flex-direction: column;
gap: 8px;
align-self: stretch;

@media (max-width: 1081px) {
  gap: 4px;
}
`

const GeneralOrLocalContainer = styled.div`
display: flex;
align-items: center;
gap: 8px;
align-self: stretch;

@media (max-width: 1081px) {
  gap: 6px;
}
`

const SubTitleContainer = styled.div`
display: flex;
height: 34px;
padding: 18px 0;
align-items: center;
gap: 10px;
align-self: stretch;
border-bottom: 2px solid var(--Neutral-Borders-Minimal, #F2F3F6);
margin-bottom: 12px;
@media (max-width: 1081px) {
  height: auto;
  padding: 16px 0 0 0;
  width: 100%;
  border-bottom: none;
  margin-bottom: 0;
 
  border-top: 2px solid var(--Neutral-Borders-Minimal, #D1D1D1);
}
`

const SubtitlePriceContainer = styled.div`
display: flex;
flex-direction: column;
align-self: stretch;

@media (max-width: 1081px) {
  width: 100%;
  flex-direction: column-reverse;
}
`

const NotesWrapper = styled.div`
display: flex;
gap: 12px;
align-self: stretch;
max-height: 365px;
position: relative;

@media (max-width: 1081px) {
  width: 100%;
  max-height: none;
}
`

const NotesContainer = styled.div`
display: flex;
flex-direction: column;
gap: 10px;
flex: 1;
overflow-y: auto;
scrollbar-width: none;
-ms-overflow-style: none;

&::-webkit-scrollbar {
  display: none;
}

@media (max-width: 1081px) {
  overflow-y: visible;
  width: 100%;
}
`

const CustomScrollbar = styled.div<{ scrollPercentage: number, isScrollable: boolean }>`
width: 8px;
height: 260px;
flex-shrink: 0;
border-radius: 30px;
background: white;
position: relative;
display: ${props => props.isScrollable ? 'block' : 'none'};
margin-top: 47px;

&::before {
  content: '';
  position: absolute;
  top: ${props => props.scrollPercentage}%;
  left: 0;
  right: 0;
  height: 94px;
  background: #B0B0B0;
  border-radius: 30px;
  transition: top 0.1s ease;
  transform: translateY(-50%);
}

@media (max-width: 1081px) {
  display: none;
}
`

const TermsAndConditionsContainer = styled.div`
display: flex;
padding: 32px;
align-items: center;
gap: 10px;
align-self: stretch;
border-radius: 10px;
background: var(--Neutral-Surface-Light, #F6F6F6);

@media (max-width: 1081px) {
  padding: 16px;
  width: 100%;
  background: white;
}
`

const ImageCarusoul = styled.div`
display: flex;
align-items: flex-start;
gap: 24px;

@media (max-width: 1081px) {
  order: 1;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  padding: 16px;
}
`



const BigImageContainer = styled.div`
width: 693px;
max-width: 693px;
aspect-ratio: 4 / 3;
max-height: 520px;
border-radius: 24px;
background: var(--Neutral-Surface-Light, #F6F6F6);
display: flex;
align-items: center;
justify-content: center;
position: relative;
overflow: hidden;
align-self: flex-start;
@media (max-width: 1081px) {
  width: 100%;
  aspect-ratio: 4 / 3;
  border-radius: 0 0 16px 16px;
}
`

const SmallImagesContainer = styled.div`
display: flex;
width: 183.739px;
flex-direction: column;
gap: 19.886px;
@media (max-width: 1081px) {
  width: 100%;
  flex-direction: row;
  gap: 12px;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
}
`


const DesktopHeaderWrapper = styled.div`
  display: block;

  @media (max-width: 1081px) {
    display: none;
  }
`

const MobileHeaderWrapper = styled.div`
  display: none;

  @media (max-width: 1081px) {
    display: block;
    order: -1;
    width: 100%;
    background-color: #16AA40;
    border: none;
  }
`



const TitleText = styled.div`
font-size: 32px;
font-weight: bold;
color: white;

@media (max-width: 1081px) {
  font-size: 20px;
}
`

const SubtitleText = styled.div`
font-size: 24px;
font-weight: normal;
color: var(--Text-color-primary, #272727);
flex: 1;
min-width: 0;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;

@media (max-width: 1081px) {
  font-size: 18px;
}
`


const CouponSlug: React.FC<CouponSlugProps> = ({ coupon, onBack, liked, onToggleLiked, orgStore }) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0)
  const [scrollPercentage, setScrollPercentage] = useState(0)
  const [isScrollable, setIsScrollable] = useState(false)
  const { timeLeft, isExpired, shouldShow } = useCountdown(coupon.endAt)

  const images = coupon.image

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget
    const scrollableHeight = scrollHeight - clientHeight

    if (scrollableHeight > 0) {
      setIsScrollable(true)
      const percentage = (scrollTop / scrollableHeight) * 100
      setScrollPercentage(percentage)
    } else {
      setIsScrollable(false)
    }
  }


  const decideBoder = (index: number) => {
    if (selectedImageIndex === index && isMobile()) {
      return '2px solid var(--Benefits-Borders-Default, #16AA40)'
    }
    if (selectedImageIndex === index) {
      return '4px solid var(--Benefits-Borders-Default, #16AA40)'
    }
    return ''
  }


  return (
    <Container>
      <SlugContainer>
        <MobileHeaderWrapper>
          <BackButtonWithCouponNameContainer>
            <BackButton onClick={onBack}><BackArrowIcon fill='white' /></BackButton>
            <CouponNameContainer>
              <GeneralOrLocalContainer>
                <CouponIcon fill='white' />
                <Text size="md" weight="normal" textcolor='white'>{coupon.type === 'general' ? 'הטבה כללית' : 'הטבה מקומית'}</Text>
              </GeneralOrLocalContainer>
              <TitleText>{coupon.title}</TitleText>
            </CouponNameContainer>
          </BackButtonWithCouponNameContainer>
        </MobileHeaderWrapper>
        <DetailsContainer>
          <DesktopHeaderWrapper>
            <BackButtonWithCouponNameContainer>
              <BackButton onClick={onBack}><BackArrowIcon fill='white' /></BackButton>
              <CouponNameContainer>
                <GeneralOrLocalContainer>
                  <CouponIcon fill='white' />
                  <Text size="md" weight="normal" textcolor='white'>{coupon.type === 'general' ? 'הטבה כללית' : `הטבה מקומית | ${orgStore}`}</Text>
                </GeneralOrLocalContainer>
                <TitleText>{coupon.title}</TitleText>
              </CouponNameContainer>
            </BackButtonWithCouponNameContainer>
          </DesktopHeaderWrapper>
          <SubtitlePriceContainer>
            <SubTitleContainer>
              <SubtitleText>{coupon.subtitle}</SubtitleText>
            </SubTitleContainer>
            <ShareSpaceBetween>
              <Text size='xl' weight='bold' textcolor='#272727'><div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}><span>{coupon.price}</span>  <span>₪</span> </div></Text>
              {shouldShow && (
                <DueDate isExpired={isExpired}>
                  <Text size='md' weight='bold' textcolor={isExpired ? 'white' : '#C80842'}>
                    {isExpired ? (
                      <>הטבה הסתיימה</>
                    ) : (
                      <>תוקף הטבה <span style={{ display: 'inline-block', width: '70px', fontFamily: 'monospace' }}>{timeLeft}</span></>
                    )}
                  </Text>
                </DueDate>
              )}
            </ShareSpaceBetween>
          </SubtitlePriceContainer>
          <NotesWrapper>
            <CustomScrollbar
              scrollPercentage={scrollPercentage}
              isScrollable={isScrollable}
            />
            <NotesContainer onScroll={handleScroll}>
              {coupon.notes.map((note, index) => (
                <TermsAndConditionsContainer key={index}>
                  <Text size='md' weight='normal' textcolor='#272727'>{note}</Text>
                </TermsAndConditionsContainer>
              ))}
            </NotesContainer>

          </NotesWrapper>
        </DetailsContainer>
        <ImageCarusoul>

          <BigImageContainer>
            <LoveIconContainer onClick={(e) => { e.stopPropagation(); onToggleLiked(); }}>
              <LoveIcon liked={liked} onClick={onToggleLiked} />
            </LoveIconContainer>
            <BlurhashImage
              src={images[selectedImageIndex]}
              blurhash={coupon.imageMetadata?.[selectedImageIndex]?.blurhash}
              alt={coupon.title}
              objectFit="cover"
              style={{
                width: '100%',
                height: '100%',
                borderRadius: '24.431px'
              }}
            />
            {coupon.companyLogo && (
              <CouponCompanyLogoWrapper>
                <img src={coupon.companyLogo} alt='company logo' />
              </CouponCompanyLogoWrapper>
            )}
          </BigImageContainer>
          <SmallImagesContainer>
            {images.map((image, index) => (
              <SmallImageContainer
                key={index}
                border={decideBoder(index)}
                onClick={() => setSelectedImageIndex(index)}
                width={'200px'}
              >
                <BlurhashImage
                  src={image}
                  blurhash={coupon.imageMetadata?.[index]?.blurhash}
                  alt={coupon.title}
                  objectFit="cover"
                  style={{
                    width: '100%',
                    height: '100%',
                    borderRadius: '10.096px'
                  }}
                />
              </SmallImageContainer>
            ))}
          </SmallImagesContainer>
        </ImageCarusoul>
      </SlugContainer>
    </Container>
  )
}

export default CouponSlug

